import { createSlice } from '@reduxjs/toolkit';

import type { SituacaoArbitral, SituacoesArbitralState } from '../types/situacaoArbitralTypes';
import {
  alterarAtivacaoSituacaoArbitral,
  atualizarEscritoriosSituacaoArbitral,
  criarSituacaoArbitral,
  editarSituacaoArbitral,
  fetchEscritoriosSituacao,
  fetchSituacoesArbitral,
} from './actions';

const initialState: SituacoesArbitralState = {
  items: [],
  escritorios: [],
  loading: false,
  saving: false,
  error: null,
};

const upsert = (state: SituacoesArbitralState, situacao: SituacaoArbitral) => {
  const index = state.items.findIndex((item) => item.id === situacao.id);
  if (index !== -1) {
    state.items[index] = situacao;
  } else {
    state.items.unshift(situacao);
  }
};

const situacoesArbitralSlice = createSlice({
  name: 'situacoesArbitral',
  initialState,
  reducers: {
    clearSituacoesArbitralError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchSituacoesArbitral.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchSituacoesArbitral.fulfilled, (state, action) => {
        state.loading = false;
        state.items = action.payload;
      })
      .addCase(fetchSituacoesArbitral.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })

      .addCase(fetchEscritoriosSituacao.fulfilled, (state, action) => {
        state.escritorios = action.payload;
      })

      .addCase(criarSituacaoArbitral.pending, (state) => {
        state.saving = true;
        state.error = null;
      })
      .addCase(criarSituacaoArbitral.fulfilled, (state, action) => {
        state.saving = false;
        upsert(state, action.payload);
      })
      .addCase(criarSituacaoArbitral.rejected, (state, action) => {
        state.saving = false;
        state.error = action.payload as string;
      })

      .addCase(editarSituacaoArbitral.pending, (state) => {
        state.saving = true;
        state.error = null;
      })
      .addCase(editarSituacaoArbitral.fulfilled, (state, action) => {
        state.saving = false;
        upsert(state, action.payload);
      })
      .addCase(editarSituacaoArbitral.rejected, (state, action) => {
        state.saving = false;
        state.error = action.payload as string;
      })

      .addCase(alterarAtivacaoSituacaoArbitral.fulfilled, (state, action) => {
        upsert(state, action.payload);
      })
      .addCase(alterarAtivacaoSituacaoArbitral.rejected, (state, action) => {
        state.error = action.payload as string;
      })

      .addCase(atualizarEscritoriosSituacaoArbitral.fulfilled, (state, action) => {
        upsert(state, action.payload);
      })
      .addCase(atualizarEscritoriosSituacaoArbitral.rejected, (state, action) => {
        state.error = action.payload as string;
      });
  },
});

export const { clearSituacoesArbitralError } = situacoesArbitralSlice.actions;
export default situacoesArbitralSlice.reducer;
